const getters = {
  userInfo: state => state.user.userInfo,
  isLogin: state => state.user.isLogin,
  isChecked: state => state.user.isChecked,
  email: state => state.user.email,
  token: state => state.user.token,
  operationCenterToken: state => state.user.operationCenterToken,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js